import "bootstrap/dist/css/bootstrap.min.css";
import "../stylesheets/style.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import TagsInput from "react-tagsinput";
import { UserConsumer } from "../../UserContext";
import { Col, Button, FormGroup, Label, Input } from "reactstrap";
import React, { useState, useContext } from "react";
import axios from "axios";
import { EmployeeLeaves_APIs } from "./EmployeeLeavesAPI";
import PreviewLeaveEmail from "./PreviewLeaveEmail";
import { AlertPopups } from "../../components/AlertPopups";

function EmailFormModal({ setToggleEmail, ProjectId, ProjectName, email }) {
	const globalState = useContext(UserConsumer);
	const defaultBcc = ["moazam.sharif@teo-intl.com"];
	const d = new Date();
	const enterKeys = [9, 13, 32, 186, 188];
	const emailRegex = /[^@]+@[^.]+\.[A-Za-z]+$/;
	const saveEmailList = (key, email = null) => {
		!localStorage.getItem(key) &&
			localStorage.setItem(key, JSON.stringify(email || []));
	};
	saveEmailList("toList", [email]);
	saveEmailList("ccList");
	saveEmailList("bccList", defaultBcc);
	const [preview, setPreview] = useState(false);
	const [toList, setToList] = useState(
		JSON.parse(localStorage.getItem("toList"))
	);
	const [ccList, setCcList] = useState(
		JSON.parse(localStorage.getItem("ccList"))
	);
	const [bccList, setBccList] = useState(
		JSON.parse(localStorage.getItem("bccList"))
	);
	const monthNames = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	const [formData, setFormData] = useState({
		ToList: "",
		CCList: "",
		BCCList: `${defaultBcc},`,
		Subject: `Team’s Tentative leave plan for ${
			monthNames[d.getMonth()]
		} ${d.getFullYear()}`,
		BodyText: `Hi, \nPlease find below the leave plan for the team as per TEO policy to update the customers.`,
		ProjectName,
		previewHTML: "false",
	});

	const onChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};
	const onSubmit = (e) => {
		e.preventDefault();
		if (toList.length === 0) {
			AlertPopups.WarningAlert.fire({
				text: `To List can not be empty`,
			});
		} else if (bccList.length === 0) {
			AlertPopups.WarningAlert.fire({
				text: `BCC List can not be empty`,
			});
		} else if (bccList.length === 0 && toList.length === 0) {
			AlertPopups.WarningAlert.fire({
				text: `BCC List and To List can not be empty`,
			});
		} else {
			const combinedToList = toList.join(",");
			const combinedCcList = ccList.join(",");
			const combinedBccList = bccList.join(",");
			const body = {
				toList: combinedToList,
				subject: formData.Subject,
				bodyText: formData.BodyText,
				projectId: ProjectId,
				projectName: formData.ProjectName,
				ccList: combinedCcList,
				bccList: combinedBccList,
				previewHTML: false,
			};
			axios
				.post(
					`${EmployeeLeaves_APIs.SendEmployeeLeaveDetailsToCustomer}`,
					body,
					{
						headers: {
							Authorization: `Bearer ${globalState.token}`,
						},
					}
				)
				.then((data) => {
					setToggleEmail();
					AlertPopups.successAlert.fire({
						text: "Email Sent",
					});
				})
				.catch((err) => {
					AlertPopups.WarningAlert.fire({
						text: err.response.data.message,
					});
				});
		}
	};

	if (preview == false) {
		return (
			<>
				<div className={`modal-wrapper`} tabindex="-1" role="dialog">
					<div className="modal-dialog modal-lg" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Send Email</h5>
								<button
									type="button"
									className="close"
									data-dismiss="modal"
									aria-label="Close"
									onClick={setToggleEmail}
								>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<form className="dataForm" onSubmit={onSubmit}>
									<FormGroup className="bottom-spacing row1 flex">
										<Label for="title" sm={2}>
											To List
											<span className="required">*</span>
										</Label>
										<Col sm={10}>
											<TagsInput
												value={toList}
												onChange={(tags) => {
													setToList(tags);
													localStorage.setItem(
														"toList",
														JSON.stringify(tags)
													);
												}}
												validationRegex={emailRegex}
												addKeys={enterKeys}
												addOnBlur
											/>
											<small>
												Emails must be separated by
												comma
											</small>
										</Col>
									</FormGroup>
									<FormGroup className="bottom-spacing row1 flex">
										<Label for="title" sm={2}>
											CC List
										</Label>
										<Col sm={10}>
											<TagsInput
												value={ccList}
												onChange={(tags) => {
													setCcList(tags);
													localStorage.setItem(
														"ccList",
														JSON.stringify(tags)
													);
												}}
												validationRegex={emailRegex}
												addKeys={enterKeys}
												addOnBlur
											/>
											<small>
												Emails must be separated by
												comma
											</small>
										</Col>
									</FormGroup>
									<FormGroup className="bottom-spacing row1 flex">
										<Label for="title" sm={2}>
											BCC List
											<span className="required">*</span>
										</Label>
										<Col sm={10}>
											<TagsInput
												value={bccList}
												onChange={(tags) => {
													setBccList(tags);
													localStorage.setItem(
														"bccList",
														JSON.stringify(tags)
													);
												}}
												validationRegex={emailRegex}
												addKeys={enterKeys}
												addOnBlur
											/>
											<small>
												Emails must be separated by
												comma
											</small>
										</Col>
									</FormGroup>
									<FormGroup className="bottom-spacing row1 flex">
										<Label for="title" sm={2}>
											Project Name
											<span className="required">*</span>
										</Label>
										<Col sm={10}>
											<Input
												type="text"
												name="project"
												id="project"
												value={formData.ProjectName}
												onChange={onChange}
												className="textfieldsize"
												required
											/>
										</Col>
									</FormGroup>
									<FormGroup className="bottom-spacing row1 flex">
										<Label for="title" sm={2}>
											Subject
											<span className="required">*</span>
										</Label>
										<Col sm={10}>
											<Input
												type="text"
												name="Subject"
												id="Subject"
												onChange={onChange}
												value={formData.Subject}
												className="textfieldsize"
												required
											/>
										</Col>
									</FormGroup>
									<FormGroup className="bottom-spacing row1 flex">
										<Label for="title" sm={2}>
											Body Text
											<span className="required">*</span>
										</Label>
										<Col sm={10}>
											<Input
												type="textarea"
												name="BodyText"
												id="BodyText"
												onChange={onChange}
												value={formData.BodyText}
												required
											/>
										</Col>
									</FormGroup>
								</form>
							</div>
							<div class="modal-footer">
								<Button
									id="row0"
									className="btnpositioin"
									onClick={() => {
										setPreview(true);
									}}
								>
									Preview
								</Button>
								<Button
									id="row0"
									type="submit"
									className="btnpositioin"
									onClick={onSubmit}
								>
									Send Email
								</Button>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	} else {
		return (
			<PreviewLeaveEmail
				token={globalState.token}
				togglePreview={setPreview}
				payload={{
					toList: toList.join(","),
					subject: formData.Subject,
					bodyText: formData.BodyText,
					projectId: ProjectId,
					projectName: formData.ProjectName,
					ccList: ccList.join(","),
					bccList: bccList.join(","),
					previewHTML: true,
				}}
			/>
		);
	}
}

export default EmailFormModal;
